import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchTechVisit({ serviceProviderId, techVisitId }) {
    return RequesterV1.get(`service_provider/tech_visits/query/show_tech_visit/${serviceProviderId}/${techVisitId}/fetch_tech_visit`);
  },
};
